export default {
  title: 'Dados Bancários',
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    success: 'Informação guardada com sucesso.',
  },
};
